import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    draft: {
        minWidth: 130,
        backgroundColor: "grey",
        color: "white",
        textAlign: "center",
        fontWeight: "bold",
        border: "solid black 2px",
        borderRadius: 5,
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: "space-evenly"
    },
    approved: {
        minWidth: 130,
        backgroundColor: "#00B71D",
        color: "white",
        textAlign: "center",
        fontWeight: "bold",
        border: "solid black 2px",
        borderRadius: 5,
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: "space-evenly"
    },
    rejected: {
        minWidth: 130,
        backgroundColor: "#FF4330",
        color: "white",
        textAlign: "center",
        fontWeight: "bold",
        border: "solid black 2px",
        borderRadius: 5,
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: "space-evenly"
    },
    historyIconContainer: {
        marginTop: 4
    },
}));

export {useStyles};